import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// [CF 2026-08-09 #17] The footer had been stripped back to a single rights
// line, which left every page ending on a bare grey strip. Rebuilt as a real
// site footer — brand + one-liner, the category list split over two columns,
// an account column and a contact column, then a slim legal bar. Kept to the
// existing palette (charcoal #2D343B, brand yellow #FFC400) and laid out with
// LOGICAL properties so it mirrors in Arabic.
//
// It still has to SIT at the bottom on short pages: the layout wrapper in
// Routes.js is a `min-height:100vh` column with the content at `flex:1 0 auto`,
// so `margin-top:auto` does that. `position` would not.

const CATEGORY_LINKS = [
  { to: '/user-cars-for-sale', key: 'Cars for Sale' },
  { to: '/user-car-dealers', key: 'Car Dealers' },
  { to: '/user-rent-car', key: 'Car Rentals' },
  { to: '/user-car-wash', key: 'Car Wash & Detailing' },
  { to: '/user-car-protection', key: 'Protection & Tinting' },
  { to: '/user-spare-parts', key: 'Spare Parts' },
  { to: '/user-quick-services', key: 'Quick Services' },
  { to: '/user-garages', key: 'Garages' },
  { to: '/user-driving-schools', key: 'Driving School' },
  { to: '/user-car-insurance', key: 'Car Insurance' },
  { to: '/user-air-conditioning', key: 'Air Conditioning' },
  { to: '/user-taxi', key: 'Taxi' },
  { to: '/user-towing', key: 'Car Towing' },
];

const SUPPORT_WHATSAPP = '96550510122';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language || '').startsWith('ar');
  const loggedIn = sessionStorage.getItem('loged_In') === 'true';
  const year = new Date().getFullYear();

  return (
    <footer className="cav-footer">
      <div className="container">
        <div className="cav-footer-grid">
          <div className="cav-footer-brand">
            <img src="assets/images/car-avenue-logo-light.svg" alt="Car Avenue" />
            <p>{t('Everything your car needs, in one place.')}</p>
            <a
              className="cav-footer-wa"
              href={`https://wa.me/${SUPPORT_WHATSAPP}`}
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-whatsapp" />
              <span>{t('Contact Support')}</span>
            </a>
          </div>

          <div className="cav-footer-col cav-footer-col--wide">
            <h6>{t('Website Categories')}</h6>
            <ul className="cav-footer-cats">
              {CATEGORY_LINKS.map((c) => (
                <li key={c.to}>
                  <Link to={c.to}>{t(c.key)}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="cav-footer-col">
            <h6>{t('My Account')}</h6>
            <ul>
              {loggedIn ? (
                <>
                  <li>
                    <Link to="/settings-edit-profile">{t('Edit Profile')}</Link>
                  </li>
                  <li>
                    <Link to="/settings-my-posts">{t('My Posts')}</Link>
                  </li>
                  <li>
                    <Link to="/settings-saved-items">{t('Saved Items')}</Link>
                  </li>
                  <li>
                    <Link to="/sp-cars-for-sale">{t('Add Car for Sale')}</Link>
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <Link to="/login">{t('login')}</Link>
                  </li>
                  <li>
                    <Link to="/register">{t('Register')}</Link>
                  </li>
                  <li>
                    <Link to="/settings-become-a-seller">
                      {t('Become a Seller')}
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </div>

      <div className="cav-footer-legal">
        <div className="container">
          <span>
            &copy; {year} Car Avenue. {t('All Rights Reserved')}
          </span>
          <span className="cav-footer-legal-links">
            <a href={`/terms-and-conditions.html${isArabic ? '?lang=ar' : ''}`}>
              {t('Terms and Conditions')}
            </a>
            <a href={`/privacy-policy.html${isArabic ? '?lang=ar' : ''}`}>
              {t('Privacy Policy')}
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
